export default import.meta.ROLLUP_FILE_URL_Bi4z2kzD;